import FlexView from "react-flexview";
import Button from "../../../modules/commons/Button";
import React from "react";
import SimpleInput from "../../../modules/SimpleInput";
import { ACTIVITY_TYPE } from "../../common/Constants";
import { FormatCurrencyWithoutSymbol } from "../../../Services/Utils";

export const tableConfig = ({ onDetailVisibilityChange, userAccess }) => [
  {
    name: "",
    label: "No",
    options: {
      customBodyRender: (_, tableMeta) => {
        const { page, rowsPerPage } = tableMeta.tableState;
        return page * rowsPerPage + tableMeta.rowIndex + 1;
      },
      setCellProps: () => ({
        style: { width: "5%" },
      }),
    },
  },
  {
    name: "mechanicManagement",
    label: "Tanggal Dokumen",
    options: {
      sort: false,
    },
  },
  {
    name: "mechanicManagementId",
    label: "Nomor Dokumen",
    options: {
      sort: false,
    },
  },
  {
    name: "effectiveDate",
    label: "Berlaku Untuk",
    options: {
      sort: false,
    },
  },
  {
    name: "mechanicManagementId",
    label: "Aksi",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "15%" },
      }),
      customBodyRender: (val, { rowIndex }) => {
        const canUpdate = userAccess.updateAccess
        const color = canUpdate ? "color-red" : "color-grey"
        return (
          <FlexView vAlignContent="center" style={{ gap: "12px" }}>
            <Button
              className="btnAct background-transparent txt-site txt-title"
              type="button"
              onClick={() => onDetailVisibilityChange(val, ACTIVITY_TYPE.VIEW)}
            >
              <i className={`fa fa-eye color-red`} />
            </Button>
            <Button
              className="btnAct background-transparent txt-site txt-title"
              type="button"
              disabled={!canUpdate}
              onClick={() => {
                if(!canUpdate){
                  return;
                }
                onDetailVisibilityChange(val, ACTIVITY_TYPE.UPDATE)
              }
              }
            >
              <i className={`fa fa-pencil-alt ${color}`} />
            </Button>
          </FlexView>
        );
      },
    },
  },
];

export const detailTableConfig = ({
  onValueChange,
  toggleRowData,
  dataTable,
  isReadonly,
}) => [
  {
    name: "",
    label: "No",
    options: {
      customBodyRender: (_, tableMeta) => {
        const { page, rowsPerPage } = tableMeta.tableState;
        return 0 * rowsPerPage + tableMeta.rowIndex + 1;
      },
      setCellProps: () => ({
        style: { width: "5%" },
      }),
    },
  },
  {
    name: "username",
    label: "Username",
    options: {
      sort: false,
    },
  },
  {
    name: "name",
    label: "Nama Lengkap",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "15%" },
      }),
    },
  },
  {
    name: "role",
    label: "Role",
    options: {
      sort: false,
    },
  },
  {
    name: "unitEntryTargetQty",
    label: "Target Unit Entry (qty)",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "15%" },
      }),
      customBodyRender: (val, { rowIndex }) => {
        if (dataTable?.[rowIndex]?.isSaved) {
          return val;
        }
        return (
          <SimpleInput
            id="input_unit_entry"
            box="number"
            name="unitEntryTargetQty"
            value={val}
            readOnly={isReadonly}
            onValueChange={({ value }) => {
              if (isReadonly) {
                return;
              }
              onValueChange(rowIndex, "unitEntryTargetQty", Number(value || 0));
            }}
          />
        );
      },
    },
  },
  {
    name: "unitServiceTargetNonKPBQty",
    label: "Target Unit Service non KPB (qty)",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "15%" },
      }),
      customBodyRender: (val, { rowIndex }) => {
        if (dataTable?.[rowIndex]?.isSaved) {
          return val;
        }
        return (
          <SimpleInput
            id="input_unit_entry"
            box="number"
            name="unitServiceTargetNonKPBQty"
            value={val}
            readOnly={isReadonly}
            onValueChange={({ value }) => {
              if (isReadonly) {
                return;
              }
              onValueChange(
                rowIndex,
                "unitServiceTargetNonKPBQty",
                Number(value || 0)
              );
            }}
          />
        );
      },
    },
  },
  {
    name: "unitServiceTargetKPBQty",
    label: "Target Unit Service KPB (qty)",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "15%" },
      }),
      customBodyRender: (val, { rowIndex }) => {
        if (dataTable?.[rowIndex]?.isSaved) {
          return val;
        }
        return (
          <SimpleInput
            id="input_unit_entry"
            box="number"
            name="unitServiceTargetKPBQty"
            value={val}
            readOnly={isReadonly}
            onValueChange={({ value }) => {
              if (isReadonly) {
                return;
              }
              onValueChange(
                rowIndex,
                "unitServiceTargetKPBQty",
                Number(value || 0)
              );
            }}
          />
        );
      },
    },
  },
  {
    name: "partTargetNonOilNonSparkPlugQty",
    label: "Target Part non Oil non Busi (Rp)",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "15%" },
      }),
      customBodyRender: (val, { rowIndex }) => {
        if (dataTable?.[rowIndex]?.isSaved) {
          return FormatCurrencyWithoutSymbol({number: val});
        }
        return (
          <SimpleInput
            id="input_unit_entry"
            box="number"
            name="partTargetNonOilNonSparkPlugQty"
            value={val}
            readOnly={isReadonly}
            onValueChange={({ value }) => {
              if (isReadonly) {
                return;
              }
              onValueChange(
                rowIndex,
                "partTargetNonOilNonSparkPlugQty",
                Number(value || 0)
              );
            }}
          />
        );
      },
    },
  },
  {
    name: "oilTargetNonKPB",
    label: "Target Oli non KPB (Rp)",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "15%" },
      }),
      customBodyRender: (val, { rowIndex }) => {
        if (dataTable?.[rowIndex]?.isSaved) {
          return FormatCurrencyWithoutSymbol({number: val});
        }
        return (
          <SimpleInput
            id="input_unit_entry"
            box="number"
            name="oilTargetNonKPB"
            value={val}
            readOnly={isReadonly}
            onValueChange={({ value }) => {
              if (isReadonly) {
                return;
              }
              onValueChange(rowIndex, "oilTargetNonKPB", Number(value || 0));
            }}
          />
        );
      },
    },
  },
  {
    name: "isSaved",
    label: "Aksi",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "15%" },
      }),
      customBodyRender: (val, { rowIndex }) => {
        const icon = val ? "fa-pencil-alt" : "fa-save";
        const color = isReadonly ? "color-grey" : "color-red";
        return (
          <FlexView vAlignContent="center" style={{ gap: "12px" }}>
            <Button
              className="btnAct background-transparent txt-site txt-title"
              type="button"
              disabled={isReadonly}
              onClick={() => {
                if (isReadonly) {
                  return;
                }
                toggleRowData(rowIndex);
              }}
            >
              <i className={`fa ${icon} ${color}`} />
            </Button>
          </FlexView>
        );
      },
    },
  },
];
